import { render, staticRenderFns } from "./user-management-icon.vue?vue&type=template&id=133da242"
import script from "./user-management-icon.vue?vue&type=script&lang=js"
export * from "./user-management-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports